<template>
  <article class="text-center my-130">
    <div class="loading mb">
      <svg-icon-component icon="spinner" class="spinning-icon icon-xl" />
    </div>
    <section v-if="preparing" id="preparingYourSub">
      <h1 class="border-none text-black mb-half">{{ tn("preparingYourSub") }}</h1>
      <div>
        <small class="text-grey">{{ tn("preparingYourSubSmall") }}</small>
      </div>
    </section>
    <section v-if="needTime" id="addingFinalTouches">
      <h1 class="border-none text-black mb-half">{{ tn("addingFinalTouches") }}</h1>
      <div>
        <small class="text-grey">{{ tn("addingFinalTouchesSmall") }}</small>
      </div>
    </section>
  </article>
</template>

<script setup lang="ts">
import { t } from "@/i18n";
import { onMounted, ref } from "vue";
import SvgIconComponent from "@/components/shared/SvgIcon/SvgIcon.vue";
import { createAolSubscription } from "./AolCreateAccountHelper";
import { useAolAccountStore } from "@/stores/AolAccount";
import { useRoute } from "vue-router";
import { useSiteSettingsStore } from "@/stores/siteSettings";

const componentName = "PreparingAol";
const baseComponentName = "CreateAolAccount";
const preparing = ref<boolean>(true);
const needTime = ref<boolean>(false);
const aolAccountStore = useAolAccountStore();
const route = useRoute();
const settingsStore = useSiteSettingsStore();

function tn(v: string, params?: Record<string, unknown>): string {
  return t(`${baseComponentName}.${v}`, params);
}

onMounted(async () => {
  settingsStore.setSkipAccountSetup(true);
  if (aolAccountStore.token) {
    createAolSubscription(aolAccountStore.token, aolAccountStore.sku, componentName);
  } else {
    createAolSubscription(route.query.token?.toString() ?? "", route.query.sku?.toString() ?? "", componentName);
  }
  showLoader();
});

async function showLoader() {
  await new Promise(resolve => setTimeout(resolve, 200000)); // 200000 milliseconds = 20 seconds
  preparing.value = !preparing.value;
  needTime.value = !needTime.value;
}
</script>
